import { useEffect, useCallback, useRef } from 'react'
export const usePreventScroll = (isOpen: boolean) => {
  const scrollData = useRef({
    scrollY: 0,
    styles: {
      position: '',
      width: '',
      top: '',
      paddingRight: '',
    },
  })
  const cleanup = useCallback(() => {
    const { scrollY, styles } = scrollData.current
    document.body.style.position = styles.position
    document.body.style.width = styles.width
    document.body.style.top = styles.top
    document.body.style.paddingRight = styles.paddingRight
    window.scrollTo(0, scrollY)
  }, [])
  useEffect(() => {
    if (!isOpen) {
      if (document.body.style.position === 'fixed') {
        cleanup()
      }
      return
    }
    // Save current values
    scrollData.current = {
      scrollY: window.scrollY,
      styles: {
        position: document.body.style.position,
        width: document.body.style.width,
        top: document.body.style.top,
        paddingRight: document.body.style.paddingRight,
      },
    }
    // Calculate scrollbar width
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    // Apply styles
    document.body.style.position = 'fixed'
    document.body.style.width = '100%'
    document.body.style.top = `-${scrollData.current.scrollY}px`
    document.body.style.paddingRight = `${scrollbarWidth}px`
    return cleanup
  }, [isOpen, cleanup])
}